export const PORTFOLIO_SCENARIO_COMPARE_REQUEST =
  "PORTFOLIO_SCENARIO_COMPARE_REQUEST";
export const PORTFOLIO_SCENARIO_COMPARE_SUCCESS =
  "PORTFOLIO_SCENARIO_COMPARE_SUCCESS";
export const PORTFOLIO_SCENARIO_COMPARE_ERROR =
  "PORTFOLIO_SCENARIO_COMPARE_ERROR";
export const PORTFOLIO_SCENARIO_COMPARE_RESET =
  "PORTFOLIO_SCENARIO_COMPARE_RESET";

export const PORTFOLIO_HEALTH_KPIS_REQUEST = "PORTFOLIO_HEALTH_KPIS_REQUEST";
export const PORTFOLIO_HEALTH_KPIS_SUCCESS = "PORTFOLIO_HEALTH_KPIS_SUCCESS";
export const PORTFOLIO_HEALTH_KPIS_ERROR = "PORTFOLIO_HEALTH_KPIS_ERROR";

export const PORTFOLIO_COMPARE_ERROR_CODES = {
  SAME_SCENARIO: "sameScenario",
  DIFFERENT_PORTFOLIO: "differentPortfolio",
  NOT_FOUND: "notFound",
  UNAUTHORIZED: "unauthorized",
  SERVER: "server",
  NETWORK: "network",
  UNKNOWN: "unknown",
};
